import { add, compareAsc, format, max, min, isValid, parseISO } from "date-fns";

export const getFormattedDate = (
  date: string | null | undefined,
): Date | null => {
  if (typeof date !== "string") {
    return null;
  }

  return new Date(date);
};

export const getFormattedDateISO = (date: string, pattern: string) => {
  return format(parseISO(date.toString()), pattern);
};

export const generateMonths = (startDate: Date, endDate: Date): Date[] => {
  let start = new Date(startDate);
  const result = [];

  while (compareAsc(start.setHours(0), endDate.setHours(0)) < 1) {
    result.push(start);
    start = add(start, { months: 1 });
  }

  return result;
};

export const getPerformanceDateDisplay = (performances: any[]): string => {
  console.log("getPerformanceDateDisplay", performances);
  const dates = (performances ?? [])
    .filter((p: any) => p?.PerformanceDate)
    .map((p: any) => new Date(p.PerformanceDate))
    .filter((d) => isValid(d));

  console.log("dates", dates);
  if (!dates.length) return "";

  const minDate = min(dates);
  const maxDate = max(dates);

  if (!isValid(minDate) || !isValid(maxDate)) return "";

  const isSameDate =
    format(minDate, "yyyy-MM-dd") === format(maxDate, "yyyy-MM-dd");

  return isSameDate
    ? format(minDate, "EEE d MMM yyyy").toUpperCase()
    : `${format(minDate, "EEE d MMM yyyy").toUpperCase()} - ${format(maxDate, "EEE d MMM yyyy").toUpperCase()}`;
};

export const isPerformanceDateValid = (performances: any[]): Boolean => {
  if (!performances || performances.length === 0) return false;

  const maxDate = performances.reduce((max, performance) => {
    const current = new Date(performance.PerformanceDate);
    return current > max ? current : max;
  }, new Date(performances[0].PerformanceDate));

  return maxDate > new Date();
};
